import { createActions } from 'redux-actions';

const actions = createActions({
  EVENTS: {
    FILTERS: {
      SET_IS_OPEN: (filter, isOpen) => ({ filter, isOpen }),
      SET_SELECTED_VALUES: (filter, selectedValues) => ({ filter, selectedValues })
    }
  }
});

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/events/actions.js